import { useOneDataFetchye } from '@americanexpress/fetchye-amex';
import { ReadBestLoyaltyBenefitsTrackersV1 } from '../utils/constants';

export const useLoyaltyBenefitsTrackersData = (requestBody) => {
  const {
    isLoading,
    error,
    data,
  } = useOneDataFetchye(ReadBestLoyaltyBenefitsTrackersV1, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: [{ ...requestBody }],
  });
  return {
    isLoading,
    error: !!error,
    data,
  };
};
